import React, { forwardRef } from "react";
import { Date_toTimeString } from "../../common/dateUtils";

type TimeInputProps = {
    defaultValue: Date;
    onBlur: (dateString: string) => void;
    inputId: string;
    label: string | undefined;
    readOnly: boolean;
    containerClassName?: string;
    errorMessage?: string;
    min?: Date;
    max?: Date;
};

const DateTimeInput = forwardRef<HTMLInputElement, TimeInputProps>(
    (
        {
            defaultValue,
            onBlur,
            inputId: id,
            label,
            readOnly = false,
            containerClassName = "",
            errorMessage = "",
            min: minValue,
            max: maxValue
        },
        ref
    ) => {
        return (
            <div className={`form-group ${containerClassName}`}>
                <label className="fw-bold form-label" htmlFor={id}>
                    {label}
                </label>
                <input
                    id={id}
                    className={`form-control ${readOnly ? "read-only-input" : ""}`}
                    type="time"
                    defaultValue={Date_toTimeString(defaultValue)}
                    ref={ref}
                    readOnly={readOnly}
                    onBlur={(e) => onBlur(e.target.value)}
                    min={minValue ? Date_toTimeString(minValue) : undefined}
                    max={maxValue ? Date_toTimeString(maxValue) : undefined}
                />
                <span className="text-danger">{errorMessage}</span>
            </div>
        );
    }
);

export default DateTimeInput;
